<template>
    <v-select
        prepend-inner-icon="verified_user"
        outlined
        dense
        v-on:input="$emit('input', $event)"
        :value="value"
        menu-props="auto"
        class="soli-round soli-grey"
        :items="certifications"
        label="Certification Level"
        :disabled="disabled"
        color="error"
    >
        <template v-slot:append>
            <v-icon color="error" v-if="alert">error_outline</v-icon>
        </template>
    </v-select>
</template>

<script>
export default {
    props: ["value", "disabled", "alert"],
    data: function () {
        return {
            certifications: ["M1", "M2", "M3", "M4", "M5"],
        };
    },
};
</script>
